// extracted by mini-css-extract-plugin
module.exports = {"searchBar":"Search_searchBar__SqBRN","select":"Search_select__JdUm5","submit":"Search_submit__Y3O_K","hits":"Search_hits__AiW9O","name":"Search_name__1xpBR"};